import { render } from "./BetslipModal.vue?vue&type=template&id=d8178400&scoped=true"
import script from "./BetslipModal.vue?vue&type=script&lang=js"
export * from "./BetslipModal.vue?vue&type=script&lang=js"

import "./BetslipModal.vue?vue&type=style&index=0&id=d8178400&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8178400"]])

export default __exports__